import { BasicRequest } from "./basicRequest";

export class DeleteBrandingRequest extends BasicRequest{

    public customerBrandingId!: number;

    constructor(){
        super();
    }
}